import { Component, OnInit } from '@angular/core';
import { NavController, NavParams, AlertController, ToastController} from 'ionic-angular'
import { AuthService } from '../../providers/auth-service';
import { UtilsProvider } from '../../providers/utils/utils';
import { CompaniasProvider } from '../../providers/companias/companias';
import { MODO_DESCONECTADO } from '../../config/url.servicio';
import { InteresesCreditosComponent } from '../../pages/intereses-creditos/intereses-creditos';
import { Storage } from '@ionic/storage'
import { CostosadicionalesPage } from '../../pages/costosadicionales/costosadicionales';
import { InteresesCreditosPorCostosAdicionalesComponent } from '../../pages/intereses-creditos-por-costos-adicionales/intereses-creditosporcostosadicionales';
import { CajaPage } from '../../pages/caja/caja';
import { PushProvider } from '../../providers/push/push';
import { ParametrosGeneralesRedux } from '../../providers/redux/parametrosgenerales/parametrosgenerales';
import { CuentasPorCobrarCreditosPage } from '../../pages/cuentas-por-cobrar-creditos/cuentas-por-cobrar-creditos';
import { ProductosRapidosComponent } from '../productos-rapidos/productos-rapidos';
import { ClientesPage } from '../../pages/clientes/clientes';
import { CuadreCajaDiarioValoresPorDenominacionPage } from '../../pages/cuadre-caja-diario-valores-por-denominacion/cuadre-caja-diario-valores-por-denominacion';
import { ParametrosCreditosPage } from '../../pages/parametros-creditos/parametros-creditos';
import { ProductosTransladosComponent } from '../productos-translados/productos-translados';
import { PermisosOpcionesUsuariosPage } from '../../pages/permisos-opciones-usuarios/permisos-opciones-usuarios';
import { CallcenterPage } from '../../pages/callcenter/callcenter';
import { HomePage } from '../../pages/home/home';
import { CajaverticalPage } from '../../pages/cajavertical/cajavertical';
@Component({
  selector: 'creditos',
  templateUrl: 'creditos.html',
  providers:[CompaniasProvider,AuthService,UtilsProvider,
    PushProvider, ParametrosGeneralesRedux
  ]
})

export class CreditosComponent implements OnInit {
  datosPagina:any[] = []
  datosPaginaReal:any[] = []
  recorrerVal:any[]
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  config: any = {};
  fields: any = [];
  constructor(public navCtrl: NavController, public navParams: NavParams,
             public alertControllers:AlertController,
             public storages:Storage,
             public auth: AuthService,
             public utils: UtilsProvider,
             public servicioCompania:CompaniasProvider,
             public servicioPush:PushProvider,
             public storage:Storage,
             public toastControllers:ToastController,
             public utilsRedux: ParametrosGeneralesRedux) {
              this.buscarPermisosPorCompania()
              if(!MODO_DESCONECTADO){
                this.dataInicial()
                this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo'])
                .then((val)=>{
                  if(val){
                    this.nombreCompaniaHeader = val['nombreCompania']
                    this.nombreCargoHeader = val['nombreCargo']
                  }
                })

                this.datosPagina = [
                    { "titulo":"Parámetros","id":1},
                    { "titulo":"Procesos","id":2}
                ]

                this.datosPaginaReal = [
                  {  "titulo":"Producto rapido","id":1,"nombre":"ProductosRapidosComponent","ruta":"ProductosRapidosComponent","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"globe"},
                  {  "titulo":"Clientes","id":1,"nombre":"ClientesPage","ruta":"ClientesPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"person"},
                  {  "titulo":"Costos adicionales","id":1,"nombre":"CostosadicionalesPage","ruta":"CostosadicionalesPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"bookmark"},
                  {  "titulo":"Intereses créditos","id":1,"nombre":"InteresesCreditosComponent","ruta":"InteresesCreditosComponent","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"bookmark"},
                  {  "titulo":"costos adicionales en créditos","id":1,"nombre":"InteresesCreditosPorCostosAdicionalesComponent","ruta":"InteresesCreditosPorCostosAdicionalesComponent","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"bookmark"},
                  {  "titulo":"Cierre caja","id":1,"nombre":"CuadreCajaDiarioValoresPorDenominacionPage","ruta":"CuadreCajaDiarioValoresPorDenominacionPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"build"},
                  {  "titulo":"Traspaso de productos","id":1,"nombre":"ProductosTransladosComponent","ruta":"ProductosTransladosComponent","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"build"},
                  {  "titulo":"Parametros créditos","id":1,"nombre":"ParametrosCreditosPage","ruta":"ParametrosCreditosPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"build"},
                  {  "titulo":"Permisos Opciones Usuario","id":1,"nombre":"PermisosOpcionesUsuariosPage","ruta":"PermisosOpcionesUsuariosPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"build"},
                  {  "titulo":"Pagar créditos","id":2,"nombre":"CuentasPorCobrarCreditosPage","ruta":"CuentasPorCobrarCreditosPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"bookmark"},
                  {  "titulo":"Seguimiento clientes","id":2,"nombre":"CallcenterPage","ruta":"CallcenterPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"bookmark"},
                  {  "titulo":"Caja","id":2,"nombre":"CajaverticalPage","ruta":"CajaverticalPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"bookmark"}

                ]
            } else {

                 this.navCtrl.setRoot('PrincipalPage');
               }

  }

    async buscarPermisosPorCompania() {
    const tienePermiso = await this.utils.verificarPermiso(
      'InteresesCreditosComponent',
      'Créditos',
      'No ha adquirido el módulo de créditos. Por favor, contacte a su administrador para más información.'
    );

    if (!tienePermiso) {
      this.navCtrl.pop(); // Solo si no tiene permiso, vuelve atrás
    }
  }


  abrirPaginaDesdeMenu(ruta:any,nombre:any){
    this.storages.get('rut').then((val)=>{
      this.recorrerVal = JSON.parse(val)
      let data = 0

      for(var i=0;i < this.recorrerVal.length;i++){
        if(this.recorrerVal[i].nombre == nombre){
          data = -1
        }
      }

      if(data!=-1){
        // this.mostrarMensajes('No tiene permisos para ingresar','Verifique..')
        this.utils.mensajeMuestro('Seguridad','No tiene permisos para ingresar. Verifique', 'warning')
      }else{
       this.irArutas(ruta)
       // this.menuControllers.close()
      }
    })
  }

  irArutas(ruta:any){
    switch(ruta){
      case "CuentasPorCobrarCreditosPage":
      this.navCtrl.push(CuentasPorCobrarCreditosPage)
      break;
      case "InteresesCreditosComponent":
      this.navCtrl.push(InteresesCreditosComponent)
      break;
      case "CostosadicionalesPage":
      this.navCtrl.push(CostosadicionalesPage)
      break;
      case "InteresesCreditosPorCostosAdicionalesComponent":
      this.navCtrl.push(InteresesCreditosPorCostosAdicionalesComponent)
      break;
      case "CajaverticalPage":
      this.navCtrl.push(CajaverticalPage)
      break;
      case "ProductosRapidosComponent":
      this.navCtrl.push(ProductosRapidosComponent)
      break;
      case "ClientesPage":
      this.navCtrl.push(ClientesPage)
      break;
      case "CuadreCajaDiarioValoresPorDenominacionPage":
      this.navCtrl.push(CuadreCajaDiarioValoresPorDenominacionPage)
      break;
      case "ParametrosCreditosPage":
      this.navCtrl.push(ParametrosCreditosPage)
      break;
      case "ProductosTransladosComponent":
        this.navCtrl.push(ProductosTransladosComponent)
      break;
      case "PermisosOpcionesUsuariosPage":
        this.navCtrl.push(PermisosOpcionesUsuariosPage)
      break;
      case "CallcenterPage":
        this.navCtrl.push(CallcenterPage)
      break;
    }
  }

  mostrarMensajes(mensaje,advertencia) {
    let alert = this.alertControllers.create({
      title: advertencia,
      subTitle: mensaje,
      buttons: ['Ok']
    });
    alert.present()
  }

  cerrarSession(){
    this.auth.logout()
    this.navCtrl.setRoot('LoginPage');
  }

  mapFields(data: any): any[] {
    let fields: any = [];

    for (let key in data) {
      if (data.hasOwnProperty(key)) {
        let field = data[key];

        // Manejo de tipo de campo basado en la estructura de datos
        if (typeof field === 'number' || typeof field === 'string') {
          // Si el campo es número o cadena, conviértelo a número si es posible
          field = typeof field === 'string' ? Number(field) : field;

          fields.push({
            label: this.capitalizeFirstLetter(key.replace(/([A-Z])/g, ' $1')), // Capitaliza la primera letra
            key: key,
            type: typeof field // Puede ser 'number' o 'string'
          });
        } else if (Array.isArray(field)) {
          if (field.length > 0 && typeof field[0] === 'object') {
            // Si es una lista de objetos, probablemente un select o multipleSelect
            fields.push({
              label: this.capitalizeFirstLetter(key.replace(/([A-Z])/g, ' $1')), // Capitaliza la primera letra
              key: key,
              type: 'multipleSelect',
              options: field.map(option => {
                // Manejo seguro de opciones para evitar errores de null/undefined
                let optionKey = Object.keys(option)[0] || '';
                return {
                  key: optionKey, // El nombre de la opción
                  value: option[optionKey] || '' // El valor asociado o cadena vacía si es null
                };
              })
            });
          } else {
            fields.push({
              label: this.capitalizeFirstLetter(key.replace(/([A-Z])/g, ' $1')), // Capitaliza la primera letra
              key: key,
              type: 'list',
              options: field // Asegúrate de que field sea un array válido
            });
          }
        } else if (typeof field === 'object') {
          // Si el campo es un objeto
          let type = field.multipleSelect === 'S' ? 'multipleSelect' : 'select';

          fields.push({
            label: this.capitalizeFirstLetter(key.replace(/([A-Z])/g, ' $1')), // Capitaliza la primera letra
            key: key,
            type: type,
            options: (field.opciones || []).map(option => {
              // Manejo seguro de opciones para evitar errores de null/undefined
              let optionKey = Object.keys(option)[0] || '';
              return {
                key: optionKey, // El nombre de la opción
                value: option[optionKey] || '' // El valor asociado o cadena vacía si es null
              };
            }),
            seleccion: field.multipleSelect === 'S' ?
                        (Array.isArray(field.seleccion) ? field.seleccion : []) :
                        (field.seleccion || []),
              multipleSelect: field.multipleSelect !== undefined && field.multipleSelect === "S" ? "true" : "false"
          });
        }
      }
    }

    return fields;
  }

  onOptionSelect(fieldKey: string, optionKey: string, selected: boolean) {
    const selectedOptions = this.config[fieldKey] || [];

    if (selected) {
      // Agrega la opción seleccionada si no está en el array
      if (!selectedOptions.includes(optionKey)) {
        selectedOptions.push(optionKey);
      }
    } else {
      // Remueve la opción si se deselecciona
      const index = selectedOptions.indexOf(optionKey);
      if (index > -1) {
        selectedOptions.splice(index, 1);
      }
    }
  }


  capitalizeFirstLetter(string: string): string {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  async ionViewDidLoad() {
    this.dataInicial()
  }

 async dataInicial() {
    let companiasId = await this.storage.get('companiasId')
    this.servicioPush.buscarParametrosGeneralesCreditos(companiasId)
    .subscribe(async (data)=>{
      let params = JSON.parse(data['_body'])
      this.config = params.data[0][0].datosCreditos

      this.cargarConfiguracion();
    },(error)=>{
      console.log(error)
    })

  }

  cargarConfiguracion() {
    let data = JSON.parse(this.config)
    this.config = data
    this.fields = this.mapFields(data);
  }
  async guardarConfig(config:any) {
    let companiasId = await this.storage.get('companiasId')
    this.servicioPush.actualizarParametrosGeneralesCreditos(companiasId,config)
    .subscribe(async (data)=>{
      this.mensajeToast('Registro guardado con exito')
      let buscarParametrosGeneralesStore: any = await this.utilsRedux.buscarParametrosGeneralesStore()
      this.utilsRedux.buscarParametrosGeneralesRedux(buscarParametrosGeneralesStore.parametrosGenerales[0].companiasId, buscarParametrosGeneralesStore.parametrosGenerales[0].usuariosId)
    },(error)=>{
      console.log(error)
    })
  }
  mensajeToast(mensaje: string) {
    let item =    {
        "duration": 1000,
        "position": "buttom"
      }
      item["message"] = mensaje;
    let toast = this.toastControllers.create(item);
    toast.present();
  }
  onSelectChange(field) {
    console.log('Seleccionado:', field);
    this.actualizarCampo(field.key, this.config[field.key].seleccion,this.config);
  }

  ngOnInit() {
    this.fields = [{"tasaMora":"0","diasHolguraParaMora":"0","cobroInteresPeriodoGracia":{"opciones":[{"No cobra":"N"},{"Distribuido en el tiempo":"D"},{"En la primera cuota":"P"}],"seleccion":"N"},"manejaInteresesEnCuentasDeCobro":{"opciones":[{"No":"N"},{"Si":"S"}],"seleccion":"N"},"visualizaEnSimulacion":{"opciones":[{"key":"interesesCorrientes","value":[{"visualiza":"N"},{"visualiza":"N"}]},{"key":"interesesMora","value":[{"visualiza":"N"},{"visualiza":"N"}]},{"key":"capitalAtrasado","value":[{"visualiza":"N"},{"visualiza":"N"}]},{"key":"costosAdicionales","value":[{"visualiza":"N"},{"visualiza":"N"}]},{"key":"fecha","value":[{"visualiza":"N"},{"visualiza":"N"}]}],"seleccion":[],"multipleSelect":"S"}}]
    // {"tasaMora":"26.5","diasHolguraParaMora":"0","cobroInteresPeriodoGracia":{"opciones":[{"No cobra":"N"},{"Distribuido en el tiempo":"D"},{"En la primera cuota":"P"}],"seleccion":"N"},"manejaInteresesEnCuentasDeCobro":{"opciones":[{"No":"N"},{"Si":"S"}],"seleccion":"S"},"visualizaEnSimulacion":{"opciones":[{"key":"interesesCorrientes","value":[{"visualiza":"S"},{"visualiza":"S"}]},{"key":"interesesMora","value":[{"visualiza":"N"},{"visualiza":"N"}]},{"key":"capitalAtrasado","value":[{"visualiza":"N"},{"visualiza":"N"}]},{"key":"costosAdicionales","value":[{"visualiza":"S"},{"visualiza":"S"}]},{"key":"fecha","value":[{"visualiza":"N"},{"visualiza":"N"}]}],"seleccion":["interesesCorrientes","costosAdicionales"],"multipleSelect":"S"}}
  }

  actualizarCampo(key: string, event: any,config:any) {
    const fieldConfig = this.config[key];
    if (!fieldConfig) {
      console.error('Campo no encontrado en config');
      return;
    }
    const seleccionArray = event;

    if (fieldConfig.opciones && Array.isArray(fieldConfig.opciones)) {
      fieldConfig.seleccion = seleccionArray.filter(val =>
        fieldConfig.opciones.some(option => option.key === val)
      );

          // Ahora actualizamos config con las nuevas selecciones
  const configField = config[key];
  if (configField && configField.opciones) {
    configField.opciones.forEach(option => {
      if (fieldConfig.seleccion.includes(option.key)) {
        // Si la opción está seleccionada, la marcamos como 'S'
        option.value.forEach(v => v.visualiza = 'S');
      } else {
        // Si no está seleccionada, la marcamos como 'N'
        option.value.forEach(v => v.visualiza = 'N');
      }
    });
  }
    } else {
      console.error('Configuración de campo inválida para actualizar');
    }
  }

dismiss() {
  this.navCtrl.setRoot(HomePage);
}
}



// WEBPACK FOOTER //
// ./src/components/creditos/creditos.ts